import styled from "styled-components"

import { color } from "../../../atoms/colors"

const colors = {
  blue: `color: ${color.primary[700]};`,
  red: `color: ${color.logoPink[400]};`,
  yellow: `color: ${color.logoYellow[600]};`,
  purple: `color: ${color.logoPurple[500]};`,
  green: `color: ${color.logoGreen[400]};`,
  black: `color: ${color.copy[900]};`,
}

export const Frame = styled.div`
  margin-top: ${(props) => `${props?.idx * 24}px`};
  flex-basis: 100%;
  @media (max-width: 992px) {
    margin-top: ${(props) => ((props?.idx + 1) % 2 === 0 ? "24px" : "0px")};
  }
  &:hover {
    .gatsby-image-wrapper {
      transform: scale(1.05);
    }
  }
`
export const ImgWrapper = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  .gatsby-image-wrapper {
    transition: transform 0.2s;
    width: 100%;
    height: 100%;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
  padding-right: 32px;
  @media (max-width: 375px) {
    padding-right: 8px;
  }
  @media (max-width: 576px) {
    gap: 8px;
  }
`

export const Eyebrow = styled.p`
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
  margin-bottom: 0px;
  @media (max-width: 576px) {
    font-size: 12px;
    line-height: 18px;
  }
  ${(props) => colors[props?.eyebrowColor]}
`
export const Heading = styled.p`
  font-family: "Avenir";
  font-style: normal;
  font-weight: 850;
  font-size: 24px;
  line-height: 32px;
  color: ${color.oxfordBlue[900]};
  margin-bottom: 0px;
  @media (max-width: 576px) {
    font-size: 18px;
    line-height: 24px;
  }
`
export const Subhead = styled.div`
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: ${color.copy[700]};
  @media (max-width: 992px) {
    font-weight: 350;
    font-size: 16px;
  }
`
